import { render, staticRenderFns } from "./SliptDropdown.vue?vue&type=template&id=ca3414b8"
import script from "./SliptDropdown.vue?vue&type=script&lang=js"
export * from "./SliptDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports